"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
var _base = _interopRequireDefault(require("@/layout/base.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/** When your routing table is too long, you can split it into small modules **/
var marketingRouter = {
  path: '/marketing',
  component: _layout.default,
  redirect: '/marketing/lottery-assistant/activity',
  name: 'Marketing',
  meta: {
    title: '营销',
    icon: 'clipboard'
  },
  children: [{
    path: 'preview-product',
    component: _base.default,
    redirect: '/marketing/preview-product/list',
    name: 'PreviewProduct',
    meta: {
      title: '商品集',
      icon: ''
    },
    children: [{
      path: 'list',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/preview-product/index'));
        });
      },
      name: 'PreviewProductList',
      meta: {
        title: '商品集管理'
      },
      hidden: true
    }, {
      path: 'operate/:id?/:op?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/preview-product/operate'));
        });
      },
      name: 'PreviewProductOperate',
      meta: {
        title: '编辑商品',
        noCache: true,
        activeMenu: "/marketing/preview-product/list"
      },
      hidden: true
    }]
  }, {
    path: 'sign',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/marketing/sign'));
      });
    },
    name: 'Sign',
    meta: {
      title: '签到',
      icon: ''
    },
    children: [{
      path: 'weekly/list',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/sign/weekly/index'));
        });
      },
      name: 'PaymentList',
      meta: {
        title: '七天签到配置管理'
      },
      hidden: true
    }, {
      path: 'weekly/operate/:id?/:op?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/sign/weekly/operate'));
        });
      },
      name: 'PaymentOperate',
      meta: {
        title: '编辑七天签到配置',
        noCache: true,
        activeMenu: "/marketing/sign/weekly/list"
      },
      hidden: true
    }, {
      path: 'config',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/sign/config/index'));
        });
      },
      name: 'signConfig',
      hidden: true,
      meta: {
        title: '签到配置',
        icon: ''
      }
    }, {
      path: 'record',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/sign/record/index'));
        });
      },
      name: 'signRecord',
      hidden: true,
      meta: {
        title: '签到记录',
        icon: ''
      }
    }]
  }, {
    path: 'sign-challenge',
    component: _base.default,
    redirect: '/marketing/sign-challenge/list',
    name: 'SignChallenge',
    meta: {
      title: '打卡挑战',
      icon: ''
    },
    children: [{
      path: 'list',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/sign-challenge/list'));
        });
      },
      name: 'SignChallengeList',
      meta: {
        title: '打卡活动管理'
      },
      hidden: true
    }, {
      path: 'operate/:id?/:op?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/sign-challenge/operate'));
        });
      },
      name: 'SignChallengeOperate',
      meta: {
        title: '编辑打卡活动',
        noCache: true,
        activeMenu: "/marketing/sign-challenge/list"
      },
      hidden: true
    }]
  }, {
    path: 'integral',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/marketing/integral/index'));
      });
    },
    name: 'Integral',
    meta: {
      title: '积分',
      icon: ''
    },
    children: [{
      path: 'integralconfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/integral/config/index'));
        });
      },
      name: 'integralConfig',
      meta: {
        title: '积分配置',
        icon: ''
      }
    }, {
      path: 'integrallog',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/integral/integralLog/index'));
        });
      },
      name: 'integralLog',
      meta: {
        title: '积分日志',
        icon: ''
      }
    }]
  },
  /*{
    path: 'draw',
    component: () => import('@/views/marketing/draw/index'),
    name: 'Draw',
    meta: { title: '抽奖', icon: '' },
    children: [
      {
        path: 'activity',
        component: () => import('@/views/marketing/draw/activity/index'),
        name: 'activity',
        meta: { title: '活动管理', icon: '' },
      },
      {
        //id:商品id，isDisabled：是否能编辑(1不能，2能)，isChoose：是否是采集商品(1是，2不是),productType:商品类型
        path: 'activity/createActivity/:id?/:operate?',
        component: () => import('@/views/marketing/draw/activity/createActivity/index'),
        name: 'creatActivity',
        meta: { title: '活动添加', noCache: true, activeMenu: `/marketing/draw/activity` },
        hidden: true,
      },
      {
        path: 'prizeRecord',
        component: () => import('@/views/marketing/draw/prizeRecord/index'),
        name: 'prizeRecord',
        meta: { title: '中奖查询', icon: '' },
      }
    ],
  },*/
  {
    path: 'lottery-assistant',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/marketing/lottery-assistant/index'));
      });
    },
    name: 'LotteryAssistant',
    meta: {
      title: '抽奖助手',
      icon: ''
    },
    children: [{
      path: 'activity',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/lottery-assistant/activity/index'));
        });
      },
      name: 'LotteryAssistantActivity',
      meta: {
        title: '活动管理',
        icon: ''
      }
    }, {
      path: 'activity/createActivity/:id?/:operate?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/lottery-assistant/activity/createActivity/index'));
        });
      },
      name: 'LotteryAssistantCreatActivity',
      meta: {
        title: '活动添加',
        noCache: true,
        activeMenu: "/marketing/lottery-assistant/activity"
      },
      hidden: true
    }, {
      path: 'record',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/lottery-assistant/record/index'));
        });
      },
      name: 'LotteryAssistantRecord',
      meta: {
        title: '中奖记录(即开即中)',
        icon: ''
      }
    }, {
      path: 'joinRecord',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/lottery-assistant/joinRecord/index'));
        });
      },
      name: 'LotteryAssistantJoinRecord',
      meta: {
        title: '中奖记录(定时开奖)',
        icon: ''
      }
    }, {
      path: 'redpacketConfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/lottery-assistant/redpacket/redpacketConfig'));
        });
      },
      name: 'RedPacketConfig',
      meta: {
        title: '红包配置',
        icon: ''
      }
    }, {
      path: 'reply',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/lottery-assistant/reply/index'));
        });
      },
      name: 'LotteryAssistantReply',
      meta: {
        title: '中奖锦鲤管理',
        icon: ''
      }
    }, {
      path: 'reply/createReply/:operate',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/lottery-assistant/reply/createReply/index'));
        });
      },
      name: 'LotteryAssistantReplyCreate',
      meta: {
        title: '锦鲤操作',
        noCache: true,
        activeMenu: "/marketing/lottery-assistant/reply"
      },
      hidden: true
    }, {
      path: 'homeMenu',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/lottery-assistant/homeMenu/index'));
        });
      },
      name: 'LotteryAssistantHomeMenu',
      meta: {
        title: '首页菜单管理',
        icon: ''
      }
    }, {
      path: 'homeMenu/createMenu/:id?/:operate?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/lottery-assistant/homeMenu/createMenu/index'));
        });
      },
      name: 'LotteryAssistantCreatMenu',
      meta: {
        title: '新增首页菜单',
        noCache: true,
        activeMenu: "/marketing/lottery-assistant/homeMenu"
      },
      hidden: true
    }]
  }, {
    path: 'fortune',
    component: _base.default,
    name: 'Fortune',
    meta: {
      title: '算命',
      icon: ''
    },
    children: [{
      path: 'ai-prompt',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/fortune/ai-prompt/index'));
        });
      },
      name: 'FortuneAiPrompt',
      meta: {
        title: 'AI对话',
        icon: ''
      }
    }, {
      path: 'ai-prompt/form/:id?/:operate?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/fortune/ai-prompt/form'));
        });
      },
      name: 'FortuneAiPromptForm',
      meta: {
        title: 'AI对话编辑',
        noCache: true,
        activeMenu: "/marketing/fortune/ai-prompt"
      },
      hidden: true
    }, {
      path: 'productConfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/fortune/product/config'));
        });
      },
      name: 'FortuneProductConfig',
      meta: {
        title: '产品配置',
        icon: ''
      }
    }, {
      path: 'order',
      name: 'FortuneOrder',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/fortune/order/index'));
        });
      },
      meta: {
        title: '订单列表',
        icon: 'clipboard'
      }
    }]
  }, {
    path: 'ads',
    component: _base.default,
    name: 'Ads',
    meta: {
      title: '广告管理',
      icon: ''
    },
    children: [{
      path: 'advList',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/ads/advList/index'));
        });
      },
      name: 'AdvList',
      meta: {
        title: '广告管理',
        icon: ''
      }
    }]
  }, {
    path: 'pop-qrcode',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/marketing/pop-qrcode/index'));
      });
    },
    name: 'PopQrcode',
    meta: {
      title: '客服管理',
      icon: ''
    },
    children: [{
      path: 'qrcodeList',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/pop-qrcode/qrcodeList/index'));
        });
      },
      name: 'QrcodeList',
      meta: {
        title: '客服管理',
        icon: ''
      }
    }, {
      path: 'qrcodeList/createQrcode/:id?/:operate?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/pop-qrcode/qrcodeList/createQrcode/index'));
        });
      },
      name: 'QrcodeListCreatActivity',
      meta: {
        title: '添加客服',
        noCache: true,
        activeMenu: "/marketing/pop-qrcode/qrcodeList"
      },
      hidden: true
    }]
  }, {
    path: 'commission',
    component: _base.default,
    name: 'commission',
    meta: {
      title: '佣金管理',
      icon: ''
    },
    children: [{
      path: 'config',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/commission/config'));
        });
      },
      name: 'Config',
      meta: {
        title: '佣金基础配置',
        icon: ''
      },
      hidden: true
    }, {
      path: 'levelConfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/commission/levelConfig'));
        });
      },
      name: 'LevelConfig',
      meta: {
        title: '佣金档位配置',
        icon: ''
      },
      hidden: true
    }]
  }, {
    path: 'free-redeem',
    component: _base.default,
    name: 'FreeRedeem',
    meta: {
      title: '免费兑换',
      icon: ''
    },
    children: [{
      path: 'list',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/free-redeem/index'));
        });
      },
      name: 'FreeRedeemList',
      meta: {
        title: '批次管理',
        icon: ''
      },
      hidden: true
    }, {
      path: 'operate/:id?/:op?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/free-redeem/operate'));
        });
      },
      name: 'FreeRedeemOperate',
      meta: {
        title: '设置兑换批次',
        noCache: true,
        activeMenu: "/marketing/free-redeem"
      },
      hidden: true
    }, {
      path: 'record',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/free-redeem/record'));
        });
      },
      name: 'FreeRedeemRecord',
      meta: {
        title: '兑换记录',
        icon: ''
      }
    }]
  },
  /*{
    path: 'seckill',
    component: () => import('@/views/marketing/seckill/index'),
    name: 'Seckill',
    meta: { title: '秒杀', icon: '' },
    children: [
      {
        path: 'config',
        component: () => import('@/views/marketing/seckill/seckillConfig/index'),
        name: 'SeckillConfig',
        meta: { title: '秒杀配置', icon: '' },
      },
      {
        path: 'list/:timeId?',
        component: () => import('@/views/marketing/seckill/seckillList/index'),
        name: 'SeckillList',
        meta: { title: '秒杀商品', icon: '' },
      },
      {
        path: 'seckillActivity',
        component: () => import('@/views/marketing/seckill/seckillActivity/index'),
        name: 'SeckillActivity',
        meta: { title: '秒杀活动', icon: '' },
      },
      {
        path: 'creatSeckill/:id?/:type?',
        component: () => import('@/views/marketing/seckill/seckillActivity/creatSeckill'),
        name: 'CreatSeckill',
        meta: { title: '添加秒杀商品', icon: '', noCache: true, activeMenu: `/marketing/seckill/seckillActivity` },
      },
    ],
  },
  {
    path: 'group',
    component: () => import('@/views/marketing/group/index'),
    name: 'Group',
    meta: { title: '拼团', icon: '' },
    children: [
      {
        path: 'activity',
        component: () => import('@/views/marketing/group/groupActivity/index'),
        name: 'GroupActivity',
        meta: { title: '拼团活动', icon: '' },
      },
      {
        path: 'list',
        component: () => import('@/views/marketing/group/groupList/index'),
        name: 'GroupList',
        meta: { title: '拼团记录', icon: '' },
      },
    ],
  },
  {
    path: 'atmosphere',
    name: 'atmosphere',
    meta: {
      title: '活动氛围',
      noCache: true,
    },
    component: () => import('@/views/marketing/atmosphere/index'),
    children: [
      {
        path: 'list',
        name: `atmosphereList`,
        meta: {
          title: '氛围列表',
          noCache: true,
        },
        component: () => import('@/views/marketing/atmosphere/atmosphereList/list'),
      },
      {
        path: 'add/:id?',
        name: `addAtmosphere`,
        meta: {
          title: '活动氛围',
          noCache: true,
          activeMenu: `/marketing/atmosphere/list`,
        },
        component: () => import('@/views/marketing/atmosphere/atmosphereList/addAtmosphere'),
      },
    ],
  },
  {
    path: 'border',
    name: 'border',
    meta: { title: '活动边框', icon: '' },
    component: () => import('@/views/marketing/border/index'),
    children: [
      {
        path: 'list',
        name: `borderList`,
        meta: {
          title: '活动边框列表',
          noCache: true,
        },
        component: () => import('@/views/marketing/atmosphere/atmosphereList/list'),
      },
      {
        path: 'add/:id?',
        name: `addBorder`,
        meta: {
          title: '活动边框',
          noCache: true,
          activeMenu: `/marketing/border/list`,
        },
        component: () => import('@/views/marketing/atmosphere/atmosphereList/addAtmosphere'),
      },
    ],
  },
  {
    path: 'broadcast',
    name: 'Broadcast',
    meta: {
      title: '直播',
      noCache: true,
    },
    component: () => import('@/views/marketing/broadcast/index'),
    children: [
      {
        path: 'list',
        name: 'BroadcastList',
        meta: {
          title: '直播间管理',
          noCache: true,
        },
        component: () => import('@/views/marketing/broadcast/list/index'),
      },
      {
        path: 'product',
        name: 'BroadcastProduct',
        meta: {
          title: '直播商品列表',
          noCache: true,
        },
        component: () => import('@/views/marketing/broadcast/product/index'),
      },
    ],
  },
  {
    path: 'PlatformCoupon',
    name: 'PlatformCoupon',
    meta: {
      title: '平台优惠券',
      noCache: true,
    },
    component: () => import('@/views/marketing/platformCoupon/index'),
    children: [
      {
        path: 'list',
        name: 'PlatformCouponlist',
        meta: {
          title: '优惠劵列表',
          noCache: true,
        },
        component: () => import('@/views/marketing/platformCoupon/couponList/index'),
      },
      {
        path: 'creatCoupon/:id?/:copy?',
        name: 'CreatCoupon',
        meta: {
          title: '添加优惠劵',
          noCache: true,
          activeMenu: `/marketing/PlatformCoupon/list`,
        },
        component: () => import('@/views/marketing/platformCoupon/couponList/creatCoupon'),
      },
      {
        path: 'couponRecord',
        name: 'couponRecord',
        meta: {
          title: '领取记录',
          noCache: true,
        },
        component: () => import('@/views/marketing/platformCoupon/couponList/record'),
      },
      {
        path: 'newGift',
        name: 'newGift',
        meta: {
          title: '用户有礼',
          noCache: true,
        },
        component: () => import('@/views/marketing/platformCoupon/couponList/newGift'),
      },
    ],
  },*/
  {
    path: 'task',
    name: 'Task',
    meta: {
      title: '每日任务管理',
      noCache: true
    },
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/marketing/task'));
      });
    },
    children: [{
      path: 'taskDefinition',
      name: 'TaskDefinition',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/task/taskDefinition/index'));
        });
      },
      meta: {
        title: '任务管理',
        icon: 'clipboard'
      }
    }, {
      path: 'userdaily',
      name: 'UserTaskDaily',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/task/userdaily/index'));
        });
      },
      meta: {
        title: '任务统计',
        icon: 'clipboard'
      }
    }, {
      path: 'userlog',
      name: 'UserTaskLog',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/task/userlog/index'));
        });
      },
      meta: {
        title: '逛商品任务浏览记录',
        icon: 'clipboard'
      }
    }]
  }, {
    path: 'feedback',
    name: 'Feedback',
    meta: {
      title: '反馈管理',
      noCache: true
    },
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/marketing/feedback'));
      });
    },
    children: [{
      path: 'list',
      name: 'FeedbackList',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/feedback/index'));
        });
      },
      meta: {
        title: '意见反馈',
        icon: 'clipboard'
      }
    }]
  }
  /*{
    path: 'videoChannel',
    name: 'VideoChannel',
    meta: {
      title: '视频号',
      noCache: true,
    },
    component: () => import('@/views/videoChannel'),
    children: [
      {
        path: 'list',
        component: () => import('@/views/videoChannel/videoList/index'),
        name: 'VideoChannelList',
        meta: { title: '商品列表', icon: '', noCache: true },
      },
      {
        path: 'draftList',
        component: () => import('@/views/videoChannel/draftList/index'),
        name: 'draftList',
        meta: { title: '草稿列表', icon: '', noCache: true },
      },
      {
        path: 'apply',
        component: () => import('@/views/videoChannel/apply/index'),
        name: 'videoApply',
        meta: { title: '申请接入', icon: '', noCache: true },
      },
      {
        path: 'weChatcategory',
        component: () => import('@/views/videoChannel/weChatcategoryAndBrand/index'),
        name: 'videoWeChatcategory',
        meta: { title: '微信商品类目', icon: '', noCache: true },
      },
    ],
  },
  {
    path: 'community',
    name: 'Community',
    meta: {
      title: '种草社区',
      noCache: true,
    },
    component: () => import('@/views/community'),
    children: [
      {
        path: 'classification',
        name: 'communityClassification',
        component: () => import('@/views/community/classification/index'),
        meta: {
          title: '社区分类',
          icon: 'clipboard',
        },
      },
      {
        path: 'topics',
        name: 'communityTopics',
        component: () => import('@/views/community/topics/index'),
        meta: {
          title: '社区话题',
          icon: 'clipboard',
        },
      },
      {
        path: 'content',
        name: 'communityContent',
        component: () => import('@/views/community/content/index'),
        meta: {
          title: '社区内容',
          icon: 'clipboard',
        },
      },
      {
        path: 'comments',
        name: 'communityComments',
        component: () => import('@/views/community/comments/index'),
        meta: {
          title: '社区评论',
          icon: 'clipboard',
        },
      },
      {
        path: 'config',
        name: 'communityConfig',
        component: () => import('@/views/community/config/index'),
        meta: {
          title: '社区配置',
          icon: 'clipboard',
        },
      },
    ],
  },
  {
    path: 'content',
    name: 'Content',
    meta: {
      title: '公告内容',
      noCache: true,
    },
    component: () => import('@/views/content'),
    children: [
      {
        path: 'articleManager',
        name: 'articleManager',
        component: () => import('@/views/content/article/list'),
        meta: {
          title: '文章管理',
          icon: 'clipboard',
        },
      },
      {
        path: 'articleCreat/:id?',
        name: 'articleCreat',
        component: () => import('@/views/content/article/edit'),
        meta: {
          title: '添加文章',
          noCache: true,
          activeMenu: `/marketing/content/articleManager`,
        },
      },
      {
        path: 'classifManager',
        name: 'classifManager',
        component: () => import('@/views/content/articleclass/list'),
        meta: {
          title: '文章分类',
          icon: 'clipboard',
        },
      },
    ],
  },
  {
    path: 'pointsMall',
    name: 'pointsMall',
    meta: {
      title: '积分商城',
      noCache: true,
    },
    component: () => import('@/views/marketing/pointsMall'),
    children: [
      {
        path: 'productManage',
        component: () => import('@/views/marketing/pointsMall/productManage/index'),
        name: 'ProductManage',
        meta: { title: '商品管理', icon: '' },
      },
      {
        //id:商品id，isDisabled：是否能编辑(1不能，2能)，isChoose：是否是采集商品(1是，2不是),productType:商品类型
        path: 'productManage/creatProduct/:id?/:isDisabled/:isChoose/:isCopy?',
        component: () => import('@/views/marketing/pointsMall/creatProduct/index'),
        name: 'creatProduct',
        meta: { title: '商品添加', noCache: true, activeMenu: `/marketing/pointsMall/productManage` },
        hidden: true,
      },
      {
        path: 'section',
        name: 'Section',
        component: () => import('@/views/marketing/pointsMall/section/index'),
        meta: {
          title: '积分区间',
          icon: 'clipboard',
        },
      },
      {
        path: 'order',
        name: 'pointsOrder',
        component: () => import('@/views/marketing/pointsMall/order/index'),
        meta: {
          title: '积分订单',
          icon: 'clipboard',
        },
      },
      {
        path: 'order/refund',
        name: 'pointsRefundOrder',
        component: () => import('@/views/marketing/pointsMall/order/refund'),
        meta: {
          title: '售后订单',
          icon: 'clipboard',
        },
      },
    ],
  },*/]
};
var _default = exports.default = marketingRouter;